var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled, { css, } from 'styled-components';
import { mapValues } from '../_internal/data';
import { breakpoints } from '../breakpoints';
import { stringifyColor } from '../color';
import { fontScale } from '../fontScale';
import { theme } from '../theme';
import { withMarkdown } from '../withMarkdown';
var size = function (name) { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", "px;\n  line-height: ", "px;\n"], ["\n  font-size: ", "px;\n  line-height: ", "px;\n"])), fontScale[name].size, fontScale[name].lineHeight); };
var baseTextStyle = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n\n  font-family: ", ";\n  font-weight: 400;\n\n  &[data-bold='true'] {\n    font-weight: 600;\n  }\n\n  > p {\n    margin: 0;\n  }\n"], ["\n  color: ", ";\n\n  font-family: ", ";\n  font-weight: 400;\n\n  &[data-bold='true'] {\n    font-weight: 600;\n  }\n\n  > p {\n    margin: 0;\n  }\n"])), theme.textColor({
    valuePropName: 'color',
    variationPropName: 'variation',
}), theme.font());
export var veryLargeTextStyle = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n\n  ", ";\n  letter-spacing: 0.02px;\n  font-weight: 300;\n\n  @media (", ") {\n    ", ";\n  }\n"], ["\n  ", ";\n\n  ", ";\n  letter-spacing: 0.02px;\n  font-weight: 300;\n\n  @media (", ") {\n    ", ";\n  }\n"])), baseTextStyle, size('nova'), breakpoints.below.smallTablet, size('sun'));
var largeTextStyle = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n\n  ", ";\n\n  @media (", ") {\n    ", ";\n  }\n"], ["\n  ", ";\n\n  ", ";\n\n  @media (", ") {\n    ", ";\n  }\n"])), baseTextStyle, size('earth'), breakpoints.below.smallTablet, size('mars'));
var emphasisTextStyle = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n\n  ", ";\n  font-weight: 500;\n\n  color: ", ";\n"], ["\n  ", ";\n\n  ", ";\n  font-weight: 500;\n\n  color: ", ";\n"])), baseTextStyle, size('mars'), theme.textColor({
    valuePropName: 'color',
    variationPropName: 'variation',
    variation: 'title',
}));
var regularTextStyle = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n\n  ", ";\n"], ["\n  ", ";\n\n  ", ";\n"])), baseTextStyle, size('moon'));
var smallTextStyle = css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n\n  ", ";\n"], ["\n  ", ";\n\n  ", ";\n"])), baseTextStyle, size('pluto'));
var captionTextStyle = css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n\n  ", ";\n"], ["\n  ", ";\n\n  ", ";\n"])), baseTextStyle, size('asteroid'));
var captionSmallTextStyle = css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n\n  ", ";\n"], ["\n  ", ";\n\n  ", ";\n"])), baseTextStyle, size('dust'));
export var textStyles = {
    veryLarge: veryLargeTextStyle,
    large: largeTextStyle,
    emphasis: emphasisTextStyle,
    regular: regularTextStyle,
    small: smallTextStyle,
    caption: captionTextStyle,
    captionSmall: captionSmallTextStyle,
};
export var RawTextComponents = mapValues(textStyles, function (style) {
    return styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), style);
});
var InnerText = React.forwardRef(function (_a, ref) {
    var inline = _a.inline, _b = _a.type, type = _b === void 0 ? 'regular' : _b, color = _a.color, props = __rest(_a, ["inline", "type", "color"]);
    var Component = RawTextComponents[type];
    return (React.createElement(Component, __assign({ ref: ref, as: inline === true ? 'span' : undefined, color: color ? stringifyColor(color) : undefined }, props)));
});
export var Text = withMarkdown({
    inline: function (props) {
        return props.inline || ['caption', 'captionSmall'].includes(props.type);
    },
})(InnerText);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=Text.js.map